(function (w, d) {
  if (w.AOS) return;

  var once = true;
  var observers = {};
  var tracked = typeof WeakSet === 'function' ? new WeakSet() : null;

  function isTracked(el) {
    return tracked ? tracked.has(el) : el.hasAttribute('data-aos-tracked');
  }

  function markTracked(el) {
    if (tracked) {
      tracked.add(el);
    } else {
      el.setAttribute('data-aos-tracked', 'true');
    }
  }

  function getObserver(offset) {
    if (observers[offset]) return observers[offset];

    observers[offset] = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('aos-animate');
            if (once) observers[offset].unobserve(entry.target);
          } else if (!once) {
            entry.target.classList.remove('aos-animate');
          }
        });
      },
      { rootMargin: '0px 0px -' + offset + 'px 0px', threshold: 0 }
    );

    return observers[offset];
  }

  function scan(defaultOffset) {
    var els = d.querySelectorAll('[data-aos]');

    els.forEach(function (el) {
      if (isTracked(el)) return;
      markTracked(el);

      var offsetAttr = el.getAttribute('data-aos-offset');
      var offset = offsetAttr ? parseInt(offsetAttr, 10) : defaultOffset;
      if (isNaN(offset)) offset = defaultOffset;

      getObserver(offset).observe(el);
    });
  }

  function init(options) {
    options = options || {};
    once = options.once !== false;

    var defaultOffset = typeof options.offset === 'number' ? options.offset : 60;
    scan(defaultOffset);

    w.AOS.refresh = function () {
      scan(defaultOffset);
    };
    w.AOS.refreshHard = w.AOS.refresh;
  }

  w.AOS = {
    init: init,
    refresh: function () {},
    refreshHard: function () {}
  };
})(window, document);
